'use strict';

angular.module('mobile-apps')
	.directive('fastList',['$compile', '$parse', '$timeout', '$rootScope', function($compile, $parse, $timeout, $rootScope) {
		return {
			restrict: 'A',
			require: ['^^fastListViewport'],
			transclude: true,
			priority: 1000,
			link: function(scope, element, attrs, parentControllers, transclude) {

				var allEntries = [];
				var entryHeights = [];
				var maxIndex = 0;
				var renderRunning = false;

				var debounceTimerLoading = null;
				var startNewRenderAfterDone = false;

				var totalHeight = 0;
				var renderedEntries = [];

				var startEntryIndex = 0;
				var endEntryIndex = -1;

				var viewportController = parentControllers[0];
				var viewport = viewportController.element;

				var scrollCounter = 0;

				// Get attributes manually because we do not want to have an
				// own scope defined.
				var adapter = $parse(attrs.adapter)(scope.$parent);
				adapter.isLoading = false;
				var numEntryPadding = parseFloat($parse(attrs.padding)(scope));


				// Create the top and bottom placeholders
				var topPaddingElement = $('<div style="background-color: #fafafa;"/>');
				var bottomPaddingElement = $('<div style="background-color: #fafafa;"/>');


				/**
				 * Adds an entry to the list
				 */
				function addEntry(i, currentEntryIndex, addEntryPosition) {
					var sourceScope = scope.$parent || scope;
					var elementScope = sourceScope.$new();

					elementScope.entryData = allEntries[i];
					elementScope['$index'] = i;

					// Get cloned element of content to add
					transclude(elementScope, function(clonedElement, innerScope) {

						if (addEntryPosition === -1) {
							// Add in beginning
							if (currentEntryIndex === 0) {
								// The very first entry gets added after
								// the placeholder
								renderedEntries.unshift(clonedElement);
								topPaddingElement.after(clonedElement);
							} else {
								// All other entries get added after the
								// entry before them
								renderedEntries.splice(currentEntryIndex, 0, clonedElement);
								$(renderedEntries[currentEntryIndex-1][1]).after(clonedElement);
							}
						} else {
							// Add to end
							renderedEntries.push(clonedElement);
							bottomPaddingElement.before(clonedElement);
						}
					});
				}


				/**
				 * Sets the loading parameter
				 */
				function setLoading(newValue) {
					if (newValue === true) {
						// Directly set to loading and make sure that the apply
						// directly runs that the view changes

						// If loading gets set again in the time the timer
						// was waiting remove it
						if (debounceTimerLoading !== null) {
							$timeout.cancel(debounceTimerLoading);
							debounceTimerLoading = null;
						}

						$timeout(function() {
							adapter.isLoading = true;
						});
					} else {
						// Wait a little bit to see if loading gets set again
						if (debounceTimerLoading === null) {

							debounceTimerLoading = $timeout(function() {
								adapter.isLoading = false;
								debounceTimerLoading = null;
							}, 125);
						}
					}
				}


				/**
				 * Renders the list
				 */
				function render() {
					setLoading(true);
					renderRunning = true;

					var currentScrollPosition = Math.min(totalHeight - viewport.height(), viewport.scrollTop());

					// Does not really matter if we render one or two entries more
					// so we use the average height
					var averageHeight = totalHeight / maxIndex;

					// Calculate the space the placeholder is allowed to
					// replace the entries before and after
					var maxSpacePlaceholder = numEntryPadding * averageHeight;

					var topPaddingElementHeight = 0;
					var bottomPaddingElementHeight = 0;

					// Calculate the boundaries
					var maxTopPlaceholderHeight = Math.max(0, currentScrollPosition - maxSpacePlaceholder);
					var minBottomPlaceholderStart = currentScrollPosition + viewport.height() + maxSpacePlaceholder;


					// Figure out which entries should be rendered
					var newStartEntryIndex = -1;
					var newEndEntryIndex = 0;
					var usedHeight = 0;
					var i;
					for (i=0;i<maxIndex;i++) {

						if (usedHeight >= maxTopPlaceholderHeight && usedHeight < minBottomPlaceholderStart) {
							// Entry is in render range
							if (newStartEntryIndex === -1) {
								// Set the first entry in range as start entry
								newStartEntryIndex = i;
							}
							// When the entry is in the correct range set it always
							// to end-entry. After it iterated over all of them
							// it will so have really the last entry which is
							// supposed to be displayed.
							newEndEntryIndex = i;
						}

						usedHeight += entryHeights[i];
					}

					// Remove no longer needed entries
					var removeEntriesBeginning = 0;
					var tempEntry;
					if (newStartEntryIndex > startEntryIndex) {
						if (newStartEntryIndex > endEntryIndex) {
							// We show now entries much later so delete all of them
							removeEntriesBeginning = endEntryIndex - startEntryIndex;
						} else {
							// A part of the entries is still needed so delete only a few
							removeEntriesBeginning = newStartEntryIndex - startEntryIndex - 1;
						}
						for (i=0;i<=removeEntriesBeginning;i++) {
							tempEntry = renderedEntries.shift();
							if (tempEntry) {
								tempEntry.remove();
							}
						}
					}

					var removeEntriesEnd = 0;
					if (newEndEntryIndex < endEntryIndex) {
						if (newEndEntryIndex < startEntryIndex) {
							// We show now entries much later so delete all of them
							removeEntriesEnd = endEntryIndex - startEntryIndex;
						} else {
							// A part of the entries is still needed so delete only a few
							removeEntriesEnd = endEntryIndex - newEndEntryIndex - 1;
						}
						for (i=0;i<=removeEntriesEnd;i++) {
							tempEntry = renderedEntries.pop();
							if (tempEntry) {
								tempEntry.remove();
							}
						}
					}


					var currentEntryIndex = -1;

					for (i=0;i<maxIndex;i++) {
						if (i < newStartEntryIndex) {
							// Add top placeholder
							topPaddingElementHeight += entryHeights[i];
						} else if (i > newEndEntryIndex) {
							// Add bottom placeholder
							bottomPaddingElementHeight += entryHeights[i];
						} else {
							// Check if entry should be rendered or if it already is
							if (i < startEntryIndex) {
								// Add entry to beginning (after top-placeholder)
								addEntry(i, ++currentEntryIndex, -1);
							} else if (i > endEntryIndex) {
								// Add entry to end (before bottom-placeholder)
								addEntry(i, ++currentEntryIndex, 1);
							}
						}
					}

					// Update the index numbers
					startEntryIndex = newStartEntryIndex;
					endEntryIndex = newEndEntryIndex;

					// Update height of top padding element
					topPaddingElement.height(topPaddingElementHeight);

					// Update height of bottom padding element
					bottomPaddingElement.height(bottomPaddingElementHeight);

					if (startNewRenderAfterDone === true) {
						$timeout(function() {
							startNewRenderAfterDone = false;
							render();
						}, 50);
					} else {
						// Loading finished so also set special variable that
						// other parts of the application can react
						setLoading(false);
					}

					if(scrollCounter > 8 && $rootScope.isDetailViewOpened){
						scrollCounter = 0;
						$timeout(function(){
							$('display-tags[entry-id=\'' + scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');
						}, 1000);		
					}

					renderRunning = false;
					scrollCounter++;
				}


				/**
				 * Updates the view but only if not already running and makes
				 * sure that it does not get called to often
				 */
				function updateView() {
					if (renderRunning === false) {
						render();
					} else {
						startNewRenderAfterDone = true;
					}
				}


				// Look out for all changes to update the displayed entries accordingly
				angular.element(viewport).bind("onmousewheel", updateView);
				angular.element(viewport).bind("onwheel", updateView);
				angular.element(viewport).bind("wheel", updateView);
				angular.element(viewport).bind("mousewheel", updateView);
				angular.element(viewport).bind("scroll", updateView);
				scope.$watch(function() { return viewport.height(); }, updateView);


				/**
				 * Scrolls to an entry with the given index
				 */
				adapter.scrollToIndex = function(index) {
					if (index && index !== 0) {
						var newScrollPosition = 0;
						var maxCountIndex = Math.min(index, maxIndex);
						for (var i=0;i<maxCountIndex;i++) {
							newScrollPosition += entryHeights[i];
						}
						viewport.scrollTop(newScrollPosition);
					}

					render();
				};


				/**
				 * Allows to manually trigger a reload of the list at current
				 * position or to scroll to a given entry
				 */
				adapter.reload = function(index) {
					// Remove all the current entries
					renderedEntries.forEach(function(entry) {
						entry.remove();
					});

					// Reset all values
					startEntryIndex = 0;
					endEntryIndex = -1;

					// Loads all the entries new
					initEntryData();

					// Scroll to entry and render list
					adapter.scrollToIndex(index);
				};


				/**
				 * Initializes the entry data
				 */
				function initEntryData() {
					allEntries = adapter.get();
					maxIndex = allEntries.length;

					// Get the height of each of the entries and calculate the
					// total height
					totalHeight = 0;
					entryHeights.length = 0;
					var height;
					allEntries.forEach(function(entry) {
						height = adapter.getHeight(entry);
						entryHeights.push(height);
						totalHeight += height;
					});
				}


				/**
				 * Initializes the list and adds the top and bottom placeholders
				 */
				function init() {
					initEntryData();

					element.append(topPaddingElement);
					element.append(bottomPaddingElement);

					$timeout(function() {
						updateView();
					}, 10);

				}

				init();
			}
		};
	}]);
